import {
  hapticsSelectionEnd,
  hapticsSelectionStart,
} from "@src/appV2/NativeAdapters/haptics.adapter";
import {
  HoldToConfirmButton as HoldToConfirmButtonBase,
  type HoldToConfirmButtonProps as HoldToConfirmButtonPropsBase,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

// FIXME: Automatically disabled during ESLint config update
interface HoldToConfirmButtonProps extends Omit<HoldToConfirmButtonPropsBase, "LinkComponent"> {}

export function HoldToConfirmButton(props: HoldToConfirmButtonProps) {
  return (
    <HoldToConfirmButtonBase
      {...props}
      LinkComponent={ButtonInternalLink}
      onConfirmStart={() => {
        void hapticsSelectionStart();
        props.onConfirmStart?.();
      }}
      onConfirmEnd={() => {
        void hapticsSelectionEnd();
        props.onConfirmEnd?.();
      }}
    />
  );
}
